export default {
  home: 'home',
  howToStart: 'how-to-start',
  subscription: 'subscription',
  evidenceDescriptionTemplateAdd: 'evidence-description-template-add',
  evidenceDescriptionTemplateEdit: 'evidence-description-template-edit',
  evidenceDescriptionTemplateAddSubcategory: 'evidence-description-template-add-subcategory',
};
